<template>
    <header class="header">
        <a 
            :href="$usuarioLogado.Modalidade.url_dashboard || '/inicio'" 
            @click.prevent="acessarInicio"
            class="logo pt-2 pt-md-0"
        >
            <img 
                :src="this.$app.caminho_logomarca" 
                border="0" 
                width="95%" 
                :title="this.$app.nome" 
                v-cloak 
            />
        </a>
        <nav 
            class="navbar navbar-expand-lg" 
            role="navigation"
        >
            <a 
                href="#" 
                @click.prevent="alternarBarraLateral" 
                class="navbar-btn sidebar-toggle" 
                data-toggle="offcanvas" 
                role="button"
            >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </a>
            <div class="navbar-right">
                <slot name="modalidade">
                    <component 
                        v-if="modalidade" 
                        :is="modalidade" 
                    >
                        <template v-if="$slots.botoes" #botoes>
                            <slot name="botoes" />
                        </template>
                        <template v-if="$slots.agenda" #agenda>
                            <slot name="agenda" />
                        </template>
                        <template v-if="$slots.aplicativos" #aplicativos>
                            <slot name="aplicativos" />
                        </template>
                        <template v-if="$slots.notificacoes" #notificacoes>
                            <slot name="notificacoes" />
                        </template>
                        <template v-if="$slots.botoes" #botoes>
                            <slot name="botoes" />
                        </template>
                    </component>
                </slot>
            </div>
        </nav>
    </header>
</template>
<script>
import { mostraMenu, escondeMenu } from '../../functions/menu'
import { removeCookieModulo } from '@/shared/common/functions/cookies'
export default {
    data() {
        return {
            modalidade: null,
        };
    },
    components: {
        ERP: () => import('./ERP'),
        NFE: () => import('./NFE'),
    },
    async mounted() {
        let modalidade = this.$usuarioLogado.Empresa.modalidade
        if (!this.$options.components[modalidade]) {
            modalidade = 'ERP'
        }
        this.modalidade = modalidade
        if (this.$isMobile() || this.$route.meta.fullScreen) {
            escondeMenu()
        }
    },
    watch: {
        $route(to, from) {
            if (to.path != from.path) {
                if (this.$isMobile() || to.meta.fullScreen) {
                    escondeMenu()
                } else {
                    mostraMenu()
                }
            }
        }
    },
    methods: {
        alternarBarraLateral() {
            const leftSide = document.querySelector('.left-side')
            if (leftSide.classList.contains('collapse-left')) {
                mostraMenu()
            } else {
                escondeMenu()
            }
        },
        acessarInicio(e) {
            this.$loading.show();
            removeCookieModulo();
            location.href = e.currentTarget.href;
        },
    }
};
</script>
<style>
header.header > .dropdown {
    float: left;
}
header.header .dropdown-toggle:after {
    content: none;
}
header.header .navbar {
    position: relative;
    min-height: 50px;
    display: block;
    flex-wrap: unset;
    padding: 0;
}
header.header .navbar-nav {
    flex-direction: unset;
}
header.header .navbar-right {
    float: right;
}
header.header .navbar-nav .user-menu .dropdown-menu {
    padding: 0;
}
@media (max-width: 424px) {
    .navbar-nav-app a.nav-link {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
}
</style>